import { useLocation, Navigate, Outlet } from "react-router-dom";
import TokenService from "../api/token.service";

const RequireAuth = ({ allowedRoles }) => {
  const token = TokenService.getLocalAccessToken();
  const location = useLocation();
  return token ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />;
};

export default RequireAuth;
